import { useAtomValue } from 'jotai'
import { createPortal } from 'react-dom'
import { initialLoadingAtom } from 'src/common/stores/store'
import Icon from 'src/common/ui-kit/Icon/Icon'

const GlobalLoader = () => {
  const loading = useAtomValue(initialLoadingAtom)

  if (!loading) return null

  return createPortal(
    <div className='fixed top-0 bottom-0 left-0 right-0 flex justify-center items-center bg-paper z-50'>
      <Icon
        name='carbon-full-logo-2'
        width='300px'
        height='auto'
        className='shine'
        style={{
          maxWidth: '80vw',
        }}
      />
    </div>,
    document.body.querySelector('#root') || document.body
  )
}

export default GlobalLoader
